import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  clearStockReportReportFilter,
  clearStockReportReportList,
  setStockReportReportFilter,
} from "../reportSlice";
import { findAllActiveItemCategory } from "../../itemcategory/services/itemcategory.services";
import { findAllActiveProductSubCategory } from "../../productsubcategory/services/productsubcategory.services";
import { IProductsubCategory } from "../../productsubcategory/productsubcategoryModel";
import { findAllActiveItem } from "../../item/services/item.services";
import { getStockReport } from "../services/reports.services";

const StockReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const ItemList = useAppSelector((state) => state.item.ItemList);
  const StockReportReportFilter = useAppSelector(
    (state) => state.reports.StockReportReportFilter,
  );
  const ItemCategoryList = useAppSelector(
    (state) => state.itemCategory?.ItemCategoryList,
  );
  const ProductSubCategoryList = useAppSelector(
    (state) => state.productsubcategory?.ProductSubCategoryList,
  );

  useEffect(() => {
    dispatch(findAllActiveItemCategory());
    dispatch(findAllActiveProductSubCategory());
    dispatch(findAllActiveItem());
    return () => {
      dispatch(clearStockReportReportFilter());
      dispatch(clearStockReportReportList());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        CategoryID: values.CategoryID ? +values.CategoryID : null,
        SubCategoryID: values.SubCategoryID ? +values.SubCategoryID : null,
        ProductID: values.ProductID ? +values.ProductID : null,
      };

      const res = await dispatch(getStockReport(payload));

      if (res.meta.requestStatus === "fulfilled") {
        window.open(
          `/stockreport/${payload.CategoryID || "0"}/${payload.SubCategoryID || "0"}/${payload.ProductID || "0"}`,
          "_blank",
        );
        dispatch(setStockReportReportFilter(payload));
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const filterSubCategory = (ItemCategoryID: number) => {
    // if (ItemCategoryID) {
    const result = ProductSubCategoryList.filter((item: any) => {
      return ItemCategoryID ? item.item_category_id === ItemCategoryID : true;
    });
    return result.map((item: IProductsubCategory) => {
      return {
        value: item?.id,
        label: item?.item_subcategory_name,
      };
    });
    // }
  };
  const filterItems = (ItemCategoryID: number, SubCategoryID: number) => {
    // if (ItemCategoryID) {
    const result = ItemList.filter((item: any) => {
      return (
        (ItemCategoryID ? item.item_category_id === ItemCategoryID : true) ||
        (SubCategoryID ? item.item_sub_category_id === SubCategoryID : true)
      );
    });
    return result?.map((item: any) => {
      return {
        value: item?.id,
        label: item?.item_name,
      };
    });
    // }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            initialValues={StockReportReportFilter}
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Stock Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={2}
                    style={{ display: "flex", gap: 10 }}
                  >
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="CategoryID"
                      label="Category"
                      placeholder="Select Category"
                      component={FormSelectionField}
                      options={ItemCategoryList?.map((item) => ({
                        value: item.ID,
                        label: item.category_name,
                      }))}
                      validator={requiredValidator}
                      astrike={true}
                    />
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="SubCategoryID"
                      label="Sub Category"
                      placeholder="Select Sub Category"
                      component={FormSelectionField}
                      options={
                        ProductSubCategoryList &&
                        filterSubCategory(
                          formRenderProps.valueGetter("CategoryID"),
                        )
                      }
                    />
                    <Field
                      wrapperStyle={{ width: "100%" }}
                      name="ProductID"
                      label="Product"
                      placeholder="Select Product"
                      component={FormSelectionField}
                      options={
                        ItemList &&
                        filterItems(
                          formRenderProps.valueGetter("CategoryID"),
                          formRenderProps.valueGetter("SubCategoryID"),
                        )
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      position: "relative",
                    }}
                  >
                    <ButtonWithLoading
                      label="GET DETAILS"
                      type="submit"
                      style={{ position: "absolute", top: 42 }}
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            )}
          />
        </ShadowCard>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default StockReportForm;
